import cn from 'classnames';
import { Image } from '../../../../components/Image/Image';
import styles from './UpsaleFirstOfferCard.module.scss'
import { formatCentsToDollars } from '../../../../services/formatCentsToDollars';

export const UpsaleFirstOfferCard = ({content,currency,status, ...props})=>{
  if(!content) return;
  const {icon,title,oldPrice,newPrice}=content;
  const old = formatCentsToDollars(oldPrice);
  const next = formatCentsToDollars(newPrice);
return (
  <div className={cn(
    styles.card,
    status==='active' && styles.active
  )}  {...props}>
    {icon && <Image src={icon} className={styles.icon}/>}
    {title && <div className={styles.title}>{content.title}</div>}
    <div className={styles.price}>
      <div className={styles.oldPrice}>{currency}{old.integer}.{old.fraction}</div>
      <div className={styles.newPrice}>
        <div className={styles.newPriceWrapper}>
          <span className={styles.currency}>{currency}</span>
          <span className={styles.main}>{next.integer}</span>
          <span className={styles.fraction}>{next.fraction}</span>
        </div>
      </div>
    </div>
  </div>
)
}